module.exports = __webpack_public_path__ + "static/media/android.2b49aaa1.svg";